<template>
  <v-dialog v-model="mostrar" max-width="800px" persistent>
    <form>
      <v-card>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>
            {{ tipo === "PARECER-RECURSO" ? "Parecer do Recurso" : "Parecer" }}
            <span v-if="analise && analise.descricao">
              - {{ analise.descricao }}</span
            >
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <!-- Campo específico para análise de Renda -->
          <div v-if="usaCadUnico && ehAnaliseRenda" class="mt-6">
            <v-select
              v-model="motivoSelecionado"
              :items="motivosRenda"
              item-text="texto"
              return-object
              label="Selecione o motivo da análise"
              outlined
              dense
              required
              :rules="[(v) => !!v || 'O motivo é obrigatório']"
              class="mb-4"
              :menu-props="{
                auto: true, // tenta se posicionar melhor
                offsetY: true, // abre para baixo (padrão, mas ajuda em alguns casos)
                closeOnClick: false,
                closeOnContentClick: false,
                maxHeight: 'auto', // ← o principal: remove limite fixo
                nudgeBottom: 8, // pequeno ajuste visual (opcional)
              }"
            ></v-select>

            <v-alert v-if="rascunho.texto" type="info" dense outlined>
              <strong>Justificativa que será enviada:</strong><br />
              {{ rascunho.texto }}
              <br />
            </v-alert>
          </div>
          <v-select v-if="tipo == 'PARECER' || tipo == 'PARECER-RECURSO'"
            :items="situacoesParecer"
            label="Situação"
            v-model="rascunho.situacao"
            item-text="label"
            item-value="value"
            :disabled="usaCadUnico && ehAnaliseRenda"
            required
          ></v-select>

          <v-dialog
            v-if="rascunho.situacao == 'DESFAVORAVEL' && tipo == 'PARECER'"
            ref="dialogDtRecurso"
            v-model="modalDataRecurso"
            :return-value.sync="rascunho.dataLimiteRecurso"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="rascunho.dataLimiteRecurso | formatDate"
                @input="rascunho.dataLimiteRecurso = $event.target.valueAsDate"
                label="Data limite para Recurso"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                required
              ></v-text-field>
            </template>
            <v-date-picker
              locale="pt-BR"
              v-model="rascunho.dataLimiteRecurso"
              @input="$refs.dialogDtRecurso.save(rascunho.dataLimiteRecurso)"
            >
            </v-date-picker>
          </v-dialog>

          <div
            v-if="rascunho.situacao == 'DESFAVORAVEL' && tipo == 'PARECER'"
            class="mb-6"
          >
            <span>
              <strong class="red--text">Atenção:</strong> A data limite para
              protocolo de recurso é de 03 (três) dias úteis contabilizados a
              partir do primeiro dia útil posterior à data de emissão do parecer
              desfavorável. Sábados, domingos, feriados e pontos facultativos
              não são considerados dias úteis para fins de definição de prazo
              para protocolo de recurso
            </span>
          </div>

          <!-- Campo de texto livre para as demais análises -->
          <v-textarea
            v-if="!usaCadUnico || !ehAnaliseRenda"
            background-color="grey lighten-3"
            v-model="rascunho.texto"
            label="Parecer"
            required
            counter
            maxlength="8000"
            rows="6"
          ></v-textarea>
        </v-card-text>

        <lista-de-upload-de-arquivos
          ref="lista"
          :item="rascunho"
        ></lista-de-upload-de-arquivos>

        <v-card-actions>
          <v-container>
            <v-row>
              <v-col xs="12">
                <v-btn block color="warning" @click="cancelarInclusaoParecer">
                  Fechar
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  block
                  color="green darken-2"
                  dark
                  @click="$refs.fileInput.click()"
                >
                  <input
                    style="display: none"
                    type="file"
                    ref="fileInput"
                    multiple
                    @change="addFile"
                  />
                  Anexar
                </v-btn>
              </v-col>
              <v-col>
                <v-btn block color="secondary" @click="salvarRascunho">
                  Salvar Rascunho
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  block
                  color="primary"
                  @click="exibirConfirmacaoSalvarParecer"
                >
                  Finalizar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </form>

    <dialogo-confirmacao
      texto="Após esta ação não será mais possível alterar os dados"
      :visivel="mostrarConfirmacaoParecer"
      @confirmar="finalizarParecer"
      @cancelar="cancelarConfirmacaoParecer"
    ></dialogo-confirmacao>
  </v-dialog>
</template>

<script>
import DialogoConfirmacao from "./DialogoConfirmacao.vue";
import * as PreMatriculaService from "@/services/prematricula.service";
import ListaDeUploadDeArquivos from "./ListaDeUploadDeArquivos.vue";
import moment from "moment";

export default {
  components: { DialogoConfirmacao, ListaDeUploadDeArquivos },

  props: {
    rascunho: {
      type: Object,
      required: true,
    },
    mostrar: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      default: "",
    },
    analise: {
      type: Object,
      default: () => ({ descricao: "Análise" }),
    },

    preMatricula: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      prematricula: null,
      modalDataRecurso: false,
      mostrarConfirmacaoParecer: false,

      situacoesParecer: [
        { label: "Favorável", value: "FAVORAVEL" },
        { label: "Desfavorável", value: "DESFAVORAVEL" },
      ],

      // Motivos pré-definidos para análise de Renda
      motivosRenda: [
        {
          situacao: "FAVORAVEL",
          texto:
            "Favorável: Folha de Resumo/Comprovante do Cadúnico atende aos critérios previstos na legislação vigente.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto: "Desfavorável: Valor acima da renda mensal per capita.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: Folha de Resumo e Comprovante do Cadúnico não enviado pelo candidato/a.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto: "Desfavorável: Folha de Resumo não enviado pelo candidato/a.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: Comprovante do Cadúnico não enviado pelo candidato/a.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: Folha de Resumo/Comprovante do Cadúnico com atualização posterior à data definida em edital.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: Folha de Resumo/Comprovante do Cadúnico desatualizado conforme exigência prevista em edital.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: Impossibilidade de visualização/leitura das informações nos documentos enviados.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: Falta do nome e assinatura do responsável pela emissão documento junto ao CRAS.",
        },
        {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: As informações constantes no Comprovante do CadÚnico são divergentes daquelas apresentadas na Folha Resumo.",
          },
          {
          situacao: "DESFAVORAVEL",
          texto:
            "Desfavorável: Código de verificação do Comprovante do Cadúnico inválido ou não encontrado com a chave de segurança informada.",
          },


        
      ],

      motivoSelecionado: null,
    };
  },

  computed: {
    ehAnaliseRenda() {
      return this.analise?.descricao === "Renda";
    },

    usaCadUnico() {
      return this.preMatricula.chamadaUtilizaCadunico;
    },
  },

  watch: {
    motivoSelecionado(novoMotivo) {
      if (novoMotivo) {
        this.rascunho.situacao = novoMotivo.situacao;
        this.rascunho.texto = novoMotivo.texto;
      }
    },

    // Limpa motivo ao fechar o diálogo
    mostrar(novoValor) {
      if (!novoValor) {
        this.motivoSelecionado = null;
      }
    },
  },

  methods: {
    cancelarConfirmacaoParecer() {
      this.mostrarConfirmacaoParecer = false;
    },

    exibirConfirmacaoSalvarParecer() {
      if (this.usaCadUnico && this.ehAnaliseRenda && !this.motivoSelecionado) {
        this.$msg.error("Selecione um motivo para a análise de Renda");
        return;
      }
      this.mostrarConfirmacaoParecer = true;
    },

    cancelarInclusaoParecer() {
      this.motivoSelecionado = null;
      this.$emit("cancelar");
    },

    salvarRascunho() {
      this.$nprogress.start();
      PreMatriculaService.salvarRascunho(this.rascunho)
        .then(() => {
          this.$msg.success("Rascunho Salvo");
          this.$emit("salvou");
        })
        .finally(() => {
          this.mostrarConfirmacaoParecer = false;
          this.$nprogress.done();
        });
    },

    finalizarParecer() {
      if (this.rascunho.situacao == "DESFAVORAVEL" && this.tipo == "PARECER") {
        if (!this.rascunho.dataLimiteRecurso) {
          this.$msg.error("Informe a data limite para recurso");
          this.cancelarConfirmacaoParecer();
          return;
        }
        if (moment(this.rascunho.dataLimiteRecurso).isSameOrBefore(moment())) {
          this.$msg.error("A Data limite deve ser posterior a data atual");
          this.cancelarConfirmacaoParecer();
          return;
        }
      }

      this.$nprogress.start();
      PreMatriculaService.finalizarParecer(this.rascunho)
        .then((res) => {
          this.$msg.success("Parecer Finalizado");
          this.$emit("finalizou", res.data);
        })
        .finally(() => {
          this.mostrarConfirmacaoParecer = false;
          this.$nprogress.done();
        });
    },

    addFile(event) {
      this.$refs.lista.addFile(event);
      this.$refs.fileInput.value = "";
    },
  },
};
</script>
